import angular from "angular";
import fundraiserItemsDialogTemplate from './fundraiserItemsDialog.html';
import './fundraiserItemsDialog.css';

/*----------------------------------------------------------------*/
/* Tab Content template IDs - These will be used to populate the  */
/* template cache so the tab content can be loaded with ngInclude */
/*----------------------------------------------------------------*/
/*-------------------*/
/* Items types tabs. */
/*-------------------*/
/** Items. */ var TID_ITEM_COSTS = 'itemCosts.template.html';
/** Fixed Items. */ var TID_FIXED_ITEMS = 'fixedCosts.template.html';
/** Planned Sales. */ var TID_PLANNED_SALES = 'plannedSales.template.html';
/** Items Summary. */ var TID_SUMMARY = 'summary.template.html';

/*----------------------*/
/* Activity types tabs. */
/*----------------------*/
/** Costs Tab. */ var TID_ACTIVITY_COSTS = 'costs.template.html';
/** Sales Tab. */ var TID_ACTIVITY_SALES = 'sales.template.html';

/* @ngInject */ export function TemplateCacheTabs($templateCache) {
  $templateCache.put(TID_ITEM_COSTS, '<items></items>');
  $templateCache.put(TID_FIXED_ITEMS, '<items></items>');
  $templateCache.put(TID_PLANNED_SALES, '<items></items>');
  $templateCache.put(TID_SUMMARY, '<summary-content></summary-content>');
  $templateCache.put(TID_ACTIVITY_COSTS, '<activity></activity>');
  $templateCache.put(TID_ACTIVITY_SALES, '<activity></activity>');
}

/*****************************************************************************
 * Constant: TabType */
/**
 * @ngdoc     constant
 * @module    csm.books.fundraisers
 * @name      csm.books.fundraisers.constant:TabType
 * @description
 * Server Fundraiser Item Types.
 *****************************************************************************/
export const TAB_TYPE = {
  ITEM_COSTS: 'ITEM_COSTS',
  FIXED_ITEMS: 'FIXED_ITEMS',
  PLANNED_SALES: 'PLANNED_SALES',
  SUMMARY: 'SUMMARY',
  ACTIVITY_COSTS: 'ACTIVITY_COSTS',
  ACTIVITY_SALES: 'ACTIVITY_SALES'
}

/*****************************************************************************
 * Constant: FundraiserItemTypes */
/**
 * @ngdoc     constant
 * @module    csm.books.fundraisers
 * @name      csm.books.fundraisers.constant:FundraiserItemTypes
 * @description
 * Server Fundraiser Item Types.
 *****************************************************************************/
export const FUNDRAISER_ITEM_TYPES = {
  ITEM_COST: 'Variable Expense',
  FIXED_ITEM: 'Fixed Expense',
  ITEM_SALE: 'Sales Item'
}

/*****************************************************************************
 * Service: FundraiserItemsDialog */
/**
 * @ngdoc     service
 * @module    csm.books.fundraisers
 * @name      csm.books.fundraisers.service:FundraiserItemsDialog
 * @description
 * Dialog used for Items/Activity management of Fundraisers and Programs.
 *****************************************************************************/
/* @ngInject */ export function FundraiserItemsDialogService($q, $uibModal, BusyScreen, FundRaiser, FundraiserItemTypes) {
  /*****************************************************************************
   * show */
  /**
   * @ngdoc    function
   * @name     show
   * @methodOf csm.books.fundraisers.FundraiserItemsDialog
   * @param    {Number}   id                 Fundraiser/Program ID.
   * @param    {String}   name               Fundraiser/Program name.
   * @param    {Boolean}  activityMode       Activity Mode.
   * @param    {Boolean}  isProgram          True=Dialog is handling a program,
   *                                         false=fundraiser.
   * @param    {Boolean}  useExpenseRevenue  True=use Expense/Revenue labels
   *                                         instead of Cost/Sales.
   * @return   {Promise}                     Resolves upon close.
   * @description
   * Displays the dialog to manage Fundraiser/Program items.
   *****************************************************************************/
  this.show = function (
    id,
    name,
    activityMode,
    isProgram,
    useExpenseRevenue
  ) {
    BusyScreen.setBusy(true);

    /*--------------------------------------------------------------*/
    /* Load fundraiser items and setup the estimated items          */
    /* dataproviders for each fundraiser item type. If in activity  */
    /* mode, load the detail information for the fundraiser ID.     */
    /* When displaying a program's info, no load item list to load. */
    /*--------------------------------------------------------------*/
    return $q
      .all([
        activityMode ? FundRaiser.getClassDetail(id) : [],
        !isProgram ? FundRaiser.getItemList(id) : []
      ])
      .then(function (resp) {
        BusyScreen.setBusy(false);
        return $uibModal.open({
          animation: false,
          backdrop: 'static',
          component: 'fundraiserItemsDialog',
          size: 'lg',
          resolve: {
            fundraiserID: function () {
              return id;
            },
            name: function () {
              return name;
            },
            activityMode: function () {
              return activityMode;
            },
            isProgram: function () {
              return isProgram;
            },
            useExpenseRevenue: function () {
              return useExpenseRevenue;
            },
            dpActualItems: function () {
              return resp[0];
            },
            dpItemCosts: function () {
              return resp[1].filter(function (fi) {
                return fi.type == FundraiserItemTypes.ITEM_COST;
              });
            },
            dpFixedItems: function () {
              return resp[1].filter(function (fi) {
                return fi.type == FundraiserItemTypes.FIXED_ITEM;
              });
            },
            dpItemSales: function () {
              return resp[1].filter(function (fi) {
                return fi.type == FundraiserItemTypes.ITEM_SALE;
              });
            }
          }
        }).result;
      });
  };
}

/*****************************************************************************
 * Component: fundraiserItemsDialog */
/**
 * @ngdoc     component
 * @module    csm.books.fundraisers
 * @name      csm.books.fundraisers.component:fundraiserItemsDialog
 * @param  {Object} modalInstance $uibModal instance from $uibModal.open method
 * @param  {Object} resolve       Resolve object passed from $uibModal.open method
 * @description
 * This component will handle the management of Fundraiser/Program items. This
 * component is expected to be used with $uibModal.
 *****************************************************************************/
export const fundraiserItemsDialogComponent = {
  template: fundraiserItemsDialogTemplate,
  bindings: { modalInstance: '<', resolve: '<' },
  controller: Controller
}

/*****************************************************************************
 * Controller: Controller */
/**
 * @ngdoc     controller
 * @module    csm.books.fundraisers
 * @methodof  csm.books.fundraisers.fundraiserItemsDialog
 * @description
 * Controller for the fundraiserItemsDialog component.
 *****************************************************************************/
/* @ngInject */ function Controller($injector, TabType, Tools) {
  var $ctrl = this;
  $ctrl.addFundItem = $injector.invoke(addFundItem, null, { $ctrl: $ctrl });
  $ctrl.getTabType = $injector.invoke(getTabType, null, { $ctrl: $ctrl });
  $ctrl.$onInit = $injector.invoke($onInit, null, { $ctrl: $ctrl });
  $ctrl.setSummaryTotals = $injector.invoke(setSummaryTotals, null, {
    $ctrl: $ctrl
  });
  $ctrl.showItemBtn = $injector.invoke(showItemBtn, null, { $ctrl: $ctrl });

  /*-------------------------------------*/
  /* Tab Objects - Default the onSelect  */
  /* property to use the empty function. */
  /*-------------------------------------*/
  $ctrl.tabItemCosts = {
    header: 'Item Costs',
    type: TabType.ITEM_COSTS,
    templateUrl: TID_ITEM_COSTS,
    onSelect: angular.noop
  };
  $ctrl.tabFixedItems = {
    header: 'Fixed Items',
    type: TabType.FIXED_ITEMS,
    templateUrl: TID_FIXED_ITEMS,
    onSelect: angular.noop
  };
  $ctrl.tabItemSales = {
    header: 'Item Sales',
    type: TabType.PLANNED_SALES,
    templateUrl: TID_PLANNED_SALES,
    onSelect: angular.noop
  };
  $ctrl.tabSummary = {
    header: 'Summary',
    type: TabType.SUMMARY,
    templateUrl: TID_SUMMARY,
    onSelect: angular.noop
  };
  $ctrl.tabCosts = {
    header: 'Costs',
    type: TabType.ACTIVITY_COSTS,
    templateUrl: TID_ACTIVITY_COSTS,
    onSelect: angular.noop
  };
  $ctrl.tabSales = {
    header: 'Sales',
    type: TabType.ACTIVITY_SALES,
    templateUrl: TID_ACTIVITY_SALES,
    onSelect: angular.noop
  };

  /*------------------------------------------*/
  /* List of tabs displayed in the component. */
  /*------------------------------------------*/
  $ctrl.tabs = [];

  /** List of fundraiser items that have been set up as item cost but not item 
    sales. This will be populated in the items component and passed to the 
    AddChangeFundraiserItemDialog. */
  $ctrl.dpItemCostsNotSold = [];

  /*------------------------------------------------------------------*/
  /* Properties on the summary object can be set by both the          */
  /* `activity` and `items` child components and displayed in the     */
  /* `summary` child component. They have to be defined here in the   */
  /* parent dialog so they can be accessed by all 3 child components. */
  /*------------------------------------------------------------------*/
  $ctrl.summary = {
    /*-----------------------*/
    /* Estimated Item Totals */
    /*-----------------------*/
    totalItemSales: 0,
    totalItemCosts: 0,
    totalFixedItems: 0,
    totalEstimatedCosts: function () {
      return Tools.roundMoney(this.totalFixedItems + this.totalItemCosts);
    },
    estimatedProfit: function () {
      return Tools.roundMoney(
        this.totalItemSales - this.totalEstimatedCosts()
      );
    },

    actualSales: 0,
    actualCosts: 0,
    actualProfit: function () {
      return Tools.roundMoney(this.actualSales - this.actualCosts);
    }
  };
}

/*****************************************************************************
 * addFundItem */
/**
 * @ngdoc    function
 * @name     addFundItem
 * @methodOf csm.books.fundraisers.fundraiserItemsDialog.controller:Controller
 * @description
 * Called when the Add Item button is clicked. Displays the dialog to add a new
 * Fundraiser Item.
 *****************************************************************************/
/* @ngInject */ function addFundItem(
  $ctrl,
  AddChangeFundraiserItemDialog,
  Alert,
  FundraiserItemTypes,
  TabType
) {
  return function () {
    /*-----------------------------------------------------------*/
    /* Create the new empty object to pass to the dialog with    */
    /* the correct type and fundraiser ID. The type is set based */
    /* on the tab that is active when the add button is clicked. */
    /*-----------------------------------------------------------*/
    var type =
      $ctrl.getTabType() === TabType.ITEM_COSTS
        ? FundraiserItemTypes.ITEM_COST
        : $ctrl.getTabType() === TabType.FIXED_ITEMS
          ? FundraiserItemTypes.FIXED_ITEM
          : FundraiserItemTypes.ITEM_SALE;

    var item = { type: type, fundraiserID: $ctrl.fundraiserID, amount: 0 };

    AddChangeFundraiserItemDialog.show(
      true,
      item,
      $ctrl.dpItemCostsNotSold
    ).then(function () {
      /*-----------------------------------*/
      /* Add the newly created item to the */
      /* dataprovider for the current tab. */
      /*-----------------------------------*/
      switch ($ctrl.getTabType()) {
        case TabType.ITEM_COSTS:
          $ctrl.dpItemCosts.push(item);
          break;
        case TabType.FIXED_ITEMS:
          $ctrl.dpFixedItems.push(item);
          break;
        case TabType.PLANNED_SALES:
          $ctrl.dpItemSales.push(item);
          break;
      }
      Alert.success(' ', 'Item Added');
    });
  };
}

/*****************************************************************************
 * getTabType */
/**
 * @ngdoc    function
 * @name     getTabType
 * @methodOf csm.books.fundraisers.fundraiserItemsDialog.controller:Controller
 * @description
 * Returns the type of the current active tab.
 *****************************************************************************/
/* @ngInject */ function getTabType($ctrl) {
  return function () {
    return $ctrl.tabs[$ctrl.activeTab].type;
  };
}

/*****************************************************************************
 * $onInit */
/**
 * @ngdoc    function
 * @name     $onInit
 * @methodOf csm.books.fundraisers.fundraiserItemsDialog.controller:Controller
 * @description
 * Called by angular when the component is ready. This will set up some
 * properties from the bound values.
 *****************************************************************************/
/* @ngInject */ function $onInit($ctrl) {
  return function () {
    /** Active Fundraiser/Program. */ $ctrl.fundraiserID =
      $ctrl.resolve.fundraiserID;
    /** Activity Mode Flag. */ $ctrl.activityMode =
      $ctrl.resolve.activityMode;
    /** Program Mode Flag. */ $ctrl.isProgram = $ctrl.resolve.isProgram;
    /** Expense/Revenue Indicator. */ $ctrl.useExpenseRevenue =
      $ctrl.resolve.useExpenseRevenue;

    /***************************************************************************
     * Dataproviders
     ***************************************************************************/
    /** Fundraiser item costs.    */ $ctrl.dpItemCosts =
      $ctrl.resolve.dpItemCosts;
    /** Fundraiser fixed items.   */ $ctrl.dpFixedItems =
      $ctrl.resolve.dpFixedItems;
    /** Fundraiser item sales.    */ $ctrl.dpItemSales =
      $ctrl.resolve.dpItemSales;
    /** Revenue/Expense activity. */ $ctrl.dpActualItems =
      $ctrl.resolve.dpActualItems;

    /*-----------------------------*/
    /* Set the modal dialog title. */
    /*-----------------------------*/
    $ctrl.title =
      ($ctrl.activityMode ? 'Activity for ' : 'Items for ') +
      ($ctrl.isProgram ? 'Program: ' : 'Fundraiser: ') +
      $ctrl.resolve.name;

    /*----------------------------------*/
    /* Set the proper tab headings when */
    /* the expense/revenue flag is set. */
    /*----------------------------------*/
    if ($ctrl.useExpenseRevenue && $ctrl.activityMode) {
      $ctrl.tabCosts.header = 'Expenses';
      $ctrl.tabSales.header = 'Revenue';
    }

    /*------------------------------------*/
    /* Set available tabs for Items mode. */
    /*------------------------------------*/
    if (!$ctrl.activityMode)
      $ctrl.tabs = [
        $ctrl.tabItemCosts,
        $ctrl.tabFixedItems,
        $ctrl.tabItemSales,
        $ctrl.tabSummary
      ];
    /*---------------------------------------*/
    /* Set available tabs for Activity mode. */
    /*---------------------------------------*/ else {
      $ctrl.tabs = [$ctrl.tabSummary, $ctrl.tabCosts, $ctrl.tabSales];

      /*---------------------------------------*/
      /* Remove the summary tab when           */
      /* displaying a program's activity data. */
      /*---------------------------------------*/
      if ($ctrl.isProgram) $ctrl.tabs.shift();
    }

    /*-------------------*/
    /* Select first tab. */
    /*-------------------*/
    $ctrl.activeTab = 0;

    /*-----------------------------------*/
    /* Add passthrough to dismiss method */
    /*-----------------------------------*/
    $ctrl.dismiss = $ctrl.modalInstance.dismiss;
  };
}

/*****************************************************************************
 * setSummaryTotals */
/**
 * @ngdoc    function
 * @name     setSummaryTotals
 * @methodOf csm.books.fundraisers.fundraiserItemsDialog.controller:Controller
 * @description
 * Calculate and set the totals on the summary object. They will displayed
 * within the summary tab component.
 *****************************************************************************/
/* @ngInject */ function setSummaryTotals(Tools, $ctrl) {
  return function () {
    /*----------------------------------------*/
    /* Utility function to totals the amounts */
    /* for the fundraiser items in an array   */
    /*----------------------------------------*/
    var getTotal = function (arr) {
      var total = 0;
      angular.forEach(arr, function (fi) {
        total += fi.subtotal;
      });

      return Tools.roundMoney(total);
    };

    $ctrl.summary.totalItemCosts = getTotal($ctrl.dpItemCosts);
    $ctrl.summary.totalFixedItems = getTotal($ctrl.dpFixedItems);
    $ctrl.summary.totalItemSales = getTotal($ctrl.dpItemSales);
  };
}

/*****************************************************************************
 * showItemBtn */
/**
 * @ngdoc    function
 * @name     showItemBtn
 * @methodOf csm.books.fundraisers.fundraiserItemsDialog.controller:Controller
 * @description
 * Returns a boolean indication to display the `Add Item` button. The button is to
 * be hidden when displaying fundraiser/program activity or when the summary tab
 * is active.
 *****************************************************************************/
/* @ngInject */ function showItemBtn($ctrl, TabType) {
  return function () {
    return (
      !$ctrl.activityMode &&
      $ctrl.tabs[$ctrl.activeTab].type !== TabType.SUMMARY
    );
  };
}
